import React from "react";
import { makeStyles } from "@material-ui/core/styles";

export const STATUS_COLORS = { ok: "#16A34A", warning: "#F59E0B", error: "#DC2626", unknown: "#94A3B8" };

const useStyles = makeStyles((theme) => ({
  row: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    padding: "10px 0",
    borderBottom: `1px solid ${theme.palette.divider}`,
    "&:last-child": { borderBottom: "none" },
  },
  dot: { width: 10, height: 10, borderRadius: 5, flexShrink: 0 },
  name: { fontSize: 14, fontWeight: 600, color: theme.palette.text.primary, minWidth: 90 },
  value: { fontSize: 14, color: theme.palette.text.secondary, flexGrow: 1, textAlign: "right" },
  hint: { display: "block", fontSize: 12, color: theme.palette.text.secondary },
}));

/** Fila de «Servicios» del Resumen del servidor (doc 0447, D6c). `status`: ok | warning | error | unknown. */
const ServiceRow = ({ name, status = "unknown", value, hint }) => {
  const classes = useStyles();
  return (
    <div className={classes.row}>
      <span className={classes.dot} style={{ backgroundColor: STATUS_COLORS[status] }} aria-hidden="true" />
      <span className={classes.name}>{name}</span>
      <span className={classes.value}>
        {value}
        {hint && <span className={classes.hint}>{hint}</span>}
      </span>
    </div>
  );
};

export default ServiceRow;
